// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1dMDl","content":"content___23r6g","header":"header___mt9_0","notes":"notes___2IK2m","upload":"upload___33Pg3","cancel":"cancel___1NhWu","spreadsheet":"spreadsheet___j8V5A","title":"title___1o-sY","addedTitle":"addedTitle___z_zis","require":"require___k-LbJ","choosefile":"choosefile___3Fo4B","filenote":"filenote___2c3Jh","action":"action___YYZB4","errorTxt":"errorTxt___1PCec","dropZone":"dropZone___46zXt","dropTxt":"dropTxt___1lT_o","preview":"preview___mbGZo","rowCheck":"rowCheck___38MWj","select":"select___2V0fj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FileUpload/FileUpload.module.css
// module id = 380
// module chunks = 0